<template>
  <el-card body-style="padding:0px 20px" shadow="never">
    <h3 class="common-title mb10">必成单分析<el-button class="ml10" type="text" @click="toEdit">编辑</el-button></h3>
    <div class="card-content">
      <div class="project-detail-content">
        <div
          :class="[
            hasNotValueFields.includes('职位产生的原因') ? 'warning-text' : '',
            'project-detail-content-title mb10',
          ]"
        >
          职位产生的原因：
        </div>
        <pre>{{ project.职位产生的原因 || '暂无职位产生的原因' }}</pre>
      </div>
      <div class="project-detail-content">
        <div
          :class="[
            hasNotValueFields.includes('最迟到岗日期') ? 'warning-text' : '',
            'project-detail-content-title mb10',
          ]"
        >
          最迟到岗日期：
        </div>
        <pre>{{ project.最迟到岗日期 || '暂无最迟到岗日期' }}</pre>
      </div>
      <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('招聘难点') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          招聘难点：
        </div>
        <pre>{{ project.招聘难点 || '暂无招聘难点' }}</pre>
      </div>
      <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('竞争预警') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          竞争预警：
        </div>
        <pre>{{ project.竞争预警 || '暂无竞争预警' }}</pre>
      </div>
    </div>

    <el-dialog
      :visible.sync="isEditing"
      custom-class="custom-dialog"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div slot="title" class="title">
        <div class="title-name">职位JD</div>
        <div class="side-title"></div>
        <!-- <div class="handle-btn">
          <el-button size="mini" type="text" @click="openHistory('项目基本信息')">操作记录</el-button>
        </div> -->
      </div>
      <div class="card-content">
        <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('职位产生的原因') ? 'warning-text' : '', 'field-label']"
            >职位产生的原因
          </span>
          <el-input
            v-model="projectInEdit.职位产生的原因"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="请输入该职位产生的原因"
          ></el-input>
        </div>
        <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('最迟到岗日期') ? 'warning-text' : '', 'field-label']"
            >最迟到岗日期
          </span>
          <el-input
            v-model="projectInEdit.最迟到岗日期"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="请输入该职位最迟到岗日期"
          ></el-input>
        </div>
        <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('招聘难点') ? 'warning-text' : '', 'field-label']">招聘难点 </span>
          <el-input
            v-model="projectInEdit.招聘难点"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="请输入该职位招聘难点"
          ></el-input>
        </div>
        <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('竞争预警') ? 'warning-text' : '', 'field-label']"
            >竞争预警<span class="field-alert">（是否有其他猎头或者内推人选在进展）</span>
          </span>
          <el-input
            v-model="projectInEdit.竞争预警"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="请输入该职位竞争预警"
          ></el-input>
        </div>
      </div>
      <div slot="footer">
        <el-row type="flex" align="center" justify="center">
          <el-button size="small" type="info" style="margin-right:20px" @click="cancelEdit">取消</el-button>
          <el-button size="small" type="primary" class="custom-primary-plain" @click="confirmEdit">保存</el-button>
        </el-row>
      </div>
    </el-dialog>
  </el-card>
</template>
<script>
import { defaultProject, defaultCompany } from '../../constant/defaultData'
import mixin from './mixin'

export default {
  mixins: [mixin],
  props: {
    project: { type: Object, default: () => window._.cloneDeep(defaultProject) },
    company: { type: Object, default: () => window._.cloneDeep(defaultCompany) },
    hasNotValueFields: { type: Array, default: () => [] },
  },
  data() {
    return {
      componentType: '必成单分析',
      fields: ['职位产生的原因', '最迟到岗日期', '招聘难点', '竞争预警'],
    }
  },
  methods: {},
}
</script>
<style scoped src="../../css/newProjectDetail.css"></style>
